import React from "react";
import PropTypes from "prop-types";

import classnames from 'classnames';

const AssetTags = ({ orgSearchPage, tags }) => (
  <div className="s-tag-section">
    <span className="s-asset-details-title modal-label">{bfTranslate('Tags')}</span>
    {tags.map((tag) => {
      if (orgSearchPage) {
        const orgSlug = window.location.pathname
          .split("organizations/")[1]
          .split("/search")[0];

        const { auto_generated, name } = tag.attributes;

        return (
          <a
            key={`tag-${tag.id}`}
            href={`/organizations/${orgSlug}/search?q=tags:"${encodeURI(name)}"`}
          >
            <span
              className={classnames('s-show-tags', 'j-main', { 'auto-generated': auto_generated })}
            >
              {name}
            </span>
          </a>
        );
      }

      const { name, auto_generated } = tag;

      if (BFG.showPageLite) { // tags not clickable in share link asset modal
        return (
          <span
            key={`tag-${tag.id}`}
            className={
              classnames('s-show-tags', 'j-main', { 'auto-generated': auto_generated }, 'share-link-tags')
            }
          >
            {tag.name}
          </span>
        );
      }

      return (
        <button
          key={`tag-${tag.id}`}
          type="button"
          className={classnames('s-show-tags', 'j-main', { 'auto-generated': auto_generated })}
          onClick={() => {
            BF.dialog.dismiss();
            BF.fx.fillInAndFilterQuery(
              `tags.strict:"${name.replace('"', '\\"')}"`
            );
          }}
        >
          {tag.name}
        </button>
      );
    })}
  </div>
);

AssetTags.propTypes = {
  orgSearchPage: PropTypes.bool,
  tags: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    auto_generated: PropTypes.bool,
  })).isRequired,
};

AssetTags.defaultProps = {
  orgSearchPage: false,
};

export default AssetTags;
